import { useMutation } from "@tanstack/react-query";
import { handleError } from "@/api/error";
import { queryClient } from "@/providers/QueryClientProviderWrapper";
import { client } from "../client";

type CreateLarkWebhookClientPayload = {
  merchantId: string;
  webhookUrl: string;
  signatureKey: string;
};

export const useCreateLarkWebhookClient = () => {
  return useMutation({
    mutationFn: async (payload: CreateLarkWebhookClientPayload) => {
      const res = await client.admin["lark-webhook-clients"].$post({
        json: payload,
      });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["admin", "lark-webhook-clients", variables.merchantId],
      });
    },
  });
};
